const PLATFORM = 'web-admin';

const SIDE_NAV_WIDTH = 240; // Defined in pixels

const REGEX_FORMAT = {
  USERNAME: /^@?([A-Za-z]+((([.]|[-]|[_]|)[a-zA-Z0-9]+)?)|[0-9]+)$/,
  EMAIL: /^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,8}$/,
};

const MAGIC_SALT = '$2a$02$0.o/O/p/E/x/S/A/L/T/';

const IMAGES_URL = `${process.env.PUBLIC_URL}/images`;

const USER_STATUS = {
  active: {
    id: 1,
    text: 'Active',
  },
  inProgress: {
    id: 2,
    text: 'In Progress',
  },
  deleted: {
    id: 3,
    text: 'Deleted',
  },
  invited: {
    id: 4,
    text: 'Invited',
  },
  created: {
    id: 5,
    text: 'Created',
  },
  suspended: {
    id: 6,
    text: 'Suspended',
  },
};

const UPGRADE_STATUS = {
  all: {
    id: null,
    text: 'All',
  },
  upgrade: {
    id: 1,
    text: 'Upgrade',
  },
  downgrade: {
    id: 0,
    text: 'Downgrade',
  },
};

const USER_REPORT_TYPE = {
  USER: 1,
  LIST: 2,
  RECOMMENDATION: 3,
  POST: 4,
};

const USER_REPORT_STATE = {
  APPROVED: 'accepted',
  REJECTED: 'declined',
  DELETED: 'deleted',
};

const GRID_ITEMS_PER_PAGE_OPTIONS = [
  {
    label: 6,
    value: 6,
  },
  {
    label: 12,
    value: 12,
  },
  {
    label: 24,
    value: 24,
  },
  {
    label: 30,
    value: 30,
  },
];

const LIST_ITEMS_PER_PAGE_OPTIONS = [
  {
    label: 7,
    value: 7,
  },
  {
    label: 10,
    value: 10,
  },
  {
    label: 50,
    value: 50,
  },
];

const CITIES_SPOT_OPTIONS = {
  all: {
    id: null,
    text: 'All',
  },
  WITH_SPOT: {
    id: 1,
    text: 'WIth Spots',
  },
  WITHOUT_SPOT: {
    id: 0,
    text: 'Without Spots',
  },
};

const SPOTS_IMAGE_OPTIONS = {
  all: {
    id: null,
    text: 'All',
  },
  WITH_NO_IMAGE: {
    id: 'no_image',
    text: 'Without Image',
  },
};

const SPOTS_STATUS_OPTIONS = {
  ALL: {
    id: null,
    text: 'All',
  },
  NEW: {
    id: 'new',
    text: 'New Photos',
  },
  SAVED: {
    id: 'saved',
    text: 'Saved',
  },
  NO_PHOTOS: {
    id: 'no_photos',
    text: 'No Photos',
  },
  MALFORMED: {
    id: 'malformed',
    text: 'Malformed',
  },
};

const SEARCH_TRIGGER_TEXT_LENGTH = 2;

const USERS_PER_PAGE = 7;

const USER_REPORTS_PER_PAGE = 7;

const DATA_PER_PAGE = 7;

const RECORDS_PER_PAGE = 7;

const CITIES_OPEN_MODAL_TYPE = {
  upload_image_modal_id: 1,
  change_name_modal_id: 2,
  merge_city_modal_id: 3,
  unmerge_city_modal_id: 4,
  tag_modal_id: 5,
};

const SPOTS_OPEN_MODAL_TYPE = {
  change_name_modal_id: 1,
  delete_modal_id: 2,
  refetch_id: 3,
};

const BUSINESS_OWNER_OPEN_MODAL_TYPE = {
  create: 1,
  edit: 2,
};

const IMG_PLACEHOLDER =
  'https://novacircle-media-integration.s3.eu-west-1.amazonaws.com/_new_uploads/nova.png';

const BUSINESS_OWNER_ROLE_ID = 3;

const now = new Date();
const threeMonthsAgo = new Date(now);
threeMonthsAgo.setMonth(threeMonthsAgo.getMonth() - 3);

const dateTicks = [
  threeMonthsAgo,
  new Date(now.getFullYear(), now.getMonth() - 1, now.getDate()),
  new Date(now.getFullYear(), now.getMonth() - 2, now.getDate()),
  now,
];
export const RECOMMENDATION_GRAPH_OPTIONS = {
  // title: 'Total upload recommendations',
  // subtitle: 'Total number of uploads per day over the last 3 months.',
  hAxis: {
    format: 'MM/dd/yyyy',
    ticks: dateTicks,
  },
  vAxis: {
    viewWindow: {
      min: 0,
    },
  },
  curveType: 'function',
  legend: { position: 'bottom' },
  series: {
    0: { pointSize: 5 }, // Configure data point size for the first series (Sales)
  },
  backgroundColor: { fill: 'transparent' }, // Make background transparent
  chartArea: {
    // Adjust chart area to remove blank space
    left: 70,
    top: 50,
    right: 50,
    width: '90%', // Use 90% of the available width
    height: '80%', // Use 80% of the available height
  },
};

export const getReportActionModalDetails = (title) => ({
  reject: {
    title: 'Reject Report',
    content: `Are you sure you want to reject this report`,
    btnConfirmTitle: 'Reject & Resolve',
  },
  edit: {
    title: `Edit ${title}`,
    content: `Are you sure you want to update this ${title} and resolve this report?`,
    btnConfirmTitle: 'UPDATE & Resolve',
  },
  delete: {
    title: `Delete ${title}`,
    content: `Are you sure you want to delete this ${title} and resolve this report?`,
    btnConfirmTitle: 'Delete & Resolve',
  },
});

const NOTIF_TYPES = {
  benefit: 'Benefit Page',
  spot: 'Spot Page',
  recommendation: 'Recommendation Page',
  recommendation_create: 'Recommendation Create Page',
  list: 'Guides Page',
  guide_create: 'Guide Create Page',
  profile: 'Profile Page',
  profile_edit: 'Profile Edit Page',
  home_for_you: 'Home For You Page',
  explore_search: 'Search Content Page',
  feature_users: 'Feature Users Page',
  wishlist_open: 'Wishlist Page',
  invite_friends: 'Invite Friends Page',
};

const constants = {
  SIDE_NAV_WIDTH,
  REGEX_FORMAT,
  MAGIC_SALT,
  PLATFORM,
  USER_STATUS,
  IMAGES_URL,
  USER_REPORT_TYPE,
  USER_REPORT_STATE,
  USERS_PER_PAGE,
  USER_REPORTS_PER_PAGE,
  UPGRADE_STATUS,
  RECORDS_PER_PAGE,
  LIST_ITEMS_PER_PAGE_OPTIONS,
  GRID_ITEMS_PER_PAGE_OPTIONS,
  SEARCH_TRIGGER_TEXT_LENGTH,
  DATA_PER_PAGE,
  IMG_PLACEHOLDER,
  CITIES_OPEN_MODAL_TYPE,
  BUSINESS_OWNER_OPEN_MODAL_TYPE,
  BUSINESS_OWNER_ROLE_ID,
  SPOTS_OPEN_MODAL_TYPE,
  RECOMMENDATION_GRAPH_OPTIONS,
  CITIES_SPOT_OPTIONS,
  SPOTS_IMAGE_OPTIONS,
  SPOTS_STATUS_OPTIONS,
  getReportActionModalDetails,
  NOTIF_TYPES,
};

export default constants;
